import { Schema } from 'yup';
import { ZodType } from 'zod';
import { FormikSchemaAdapter, zodToFormikSchema } from './ZodFormikAdapter';

export type FormSchema<TValues> = Schema<TValues> | ZodType<TValues>;

export function toFormikValidationSchema<TValues>(
  schema: FormSchema<TValues>,
): FormikSchemaAdapter<TValues> | Schema<TValues> {
  return isZodSchema(schema) ? zodToFormikSchema(schema) : schema;
}

function isZodSchema<TValues>(
  schema: FormSchema<TValues>,
): schema is ZodType<TValues> {
  return typeof (schema as ZodType).safeParse === 'function';
}
